




































































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import { DropDownResponse } from '@/services/__model';

@Component
export default class SiblingInfo extends Vue {
  @Prop() public studySchoolList!: Array<DropDownResponse>;
  @Prop() public itemInfo!: any;
  public name: string = '';
  public gender: string = '';
  public birthday: Moment | undefined = moment();
  public schoolNowName: string = '';
  public studySchoolIsOther: boolean = false;
  public moment = moment;
  public schoolNowExtra: string = '';
  public schoolNow: string = '';

  public get locale(): string {
    return this.$i18n.locale;
  }

  public created(): void {
    this.birthday = undefined;
  }

  public mounted(): void {
    if (this.itemInfo) {
      this.name = this.itemInfo.name;
      this.gender = this.itemInfo.gender;
      this.birthday = this.itemInfo.birthday ? moment(this.itemInfo.birthday) : undefined;
      this.schoolNowExtra = this.itemInfo.schoolNowExtra ? this.itemInfo.schoolNowExtra : undefined;
    }
  }

  public onChildrenNameChange(e: any): void {
    const value = e.target.value;
    if (value.length < 50) {
      this.name = e.target.value;
    } else {
      this.$message.error(this.$tc('warningTip.siblingNameInvaild'));
    }
  }

  public changeName(): void {
    this.$emit('changeSiblingInfo', this.getSiblingInfo());
  }

  public disabledDate(current: Moment) {
    return current && current > moment().endOf('day');
  }

  public onGenderChange(e: any): void {
    this.gender = e.target.value;
    this.$emit('changeSiblingInfo', this.getSiblingInfo());
  }

  public handleSchoolExtra(e: any): void {
    if (e.target.value.length < 50) {
      this.schoolNowExtra = e.target.value;
    } else {
      this.$message.error(this.$tc('warningTip.schoolExtraInvaild'));
    }
  }

  public onDateOfBirthChange(date: any, dateString: any): void {
    this.birthday = date;
    this.$emit('changeSiblingInfo', this.getSiblingInfo());
  }

  public getSiblingInfo(): any {
    return {
      id: this.itemInfo.id,
      name: this.name || this.itemInfo.name,
      gender: this.gender || this.itemInfo.gender,
      birthday: this.birthday || this.itemInfo.birthday,
      schoolNowExtra: this.schoolNowExtra,
    };
  }

  public deleteItem(id: any): void {
    this.$emit('deleteItem', id);
  }
}
